import { ReactElement, ReactNode } from 'react'
import { ID } from 'types/entity'
import { Option } from '../dialogs/Menu'
import { IconType } from 'core/components/icons/types'

export const buildOptionsMap = <T extends { token_id: ID }>(
  options: Option<T>[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  map: Map<any, any> = new Map()
) => {
  options.forEach((opt) => {
    if (typeof opt === 'string' || typeof opt === 'number') {
      return map.set(opt, opt)
    }
    if ('token_id' in opt) return map.set(opt.token_id, opt)
    if ('props' in opt) return map.set(opt.props.value, opt)
    if ('items' in opt) return buildOptionsMap(opt.items, map)
  })
  return map
}

export const buildOptionsList = <T extends { token_id: ID }>(
  options: Option<T>[],
  arr: Array<
    | {
        token_id: string | number
        label: ReactNode
        subLabel?: ReactNode
        menuElement?: ReactNode
        prefix?: `${IconType}` | ReactElement
        suffix?: `${IconType}` | ReactElement
        disabled?: boolean
        level: number
        bottomBorder?: boolean
      }
    | { groupLabel: ReactNode; level: number }
  > = [],
  level = 0
) => {
  options.forEach((opt) => {
    if (typeof opt === 'string' || typeof opt === 'number') {
      return arr.push({
        token_id: opt,
        label: opt,
        level
      })
    }
    if ('token_id' in opt) {
      return arr.push({ ...opt, level })
    }
    if ('groupLabel' in opt) {
      arr.push({
        groupLabel: opt.groupLabel,
        level
      })
      return buildOptionsList(opt.items, arr, level + 1)
    }
    if ('props' in opt)
      return arr.push({
        token_id: opt.props.value,
        label: opt,
        level,
        disabled: opt.props.disabled
      })
  })
  return arr
}
